// Mirror of contracts/src/libraries/HashcurveParams.sol — pinned by test/params.test.ts.
export const TOTAL_SUPPLY = 1_000_000_000n * 10n ** 18n;
export const CURVE_SUPPLY = 800_000_000n * 10n ** 18n;
export const LP_SUPPLY = 200_000_000n * 10n ** 18n;
export const LOT = 4_000_000n * 10n ** 18n;
export const N_LOTS = Number(CURVE_SUPPLY / LOT); // 200

export const VIRTUAL_TOKEN_0 = (CURVE_SUPPLY * CURVE_SUPPLY) / (CURVE_SUPPLY - LP_SUPPLY);
export const VIRTUAL_QUOTE_0 = 10n ** 18n;
export const GRADUATION_RESERVE = 3n * 10n ** 18n; // nominal; exact value may exceed by rounding dust

export const BPS = 10_000n;
export const CURVE_FEE_BPS = 100n;
export const CURVE_CREATOR_SHARE_BPS = 3_000n;
export const LP_CREATOR_SHARE_BPS = 5_000n;

export const TARGET_INTERVAL = 15n;
export const RETARGET_TAU = 30n;
export const MAX_AGE_COUNTED = 60n;
export const MAX_STEP = 4n;
export const IDLE_GRACE = 60n;
export const IDLE_HALFLIFE = 30n;

export const START_TARGET = 1n << 218n;
export const MAX_TARGET = 1n << 236n;
export const MIN_TARGET = 1n << 192n;

export const MAX_START_DELAY = 7n * 24n * 3600n;
export const MAX_UINT256 = (1n << 256n) - 1n;
